import React from 'react';
import './Footer.css';
// import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container' id="contact">
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Please contact me with any questions, for a copy of my CV or for a collaboration
        </p>
      </section>
      <section class='social-media'>
        <div class='social-media-wrap'>
          <div class='footer-logo'>
            <Link to='/' className='social-logo'>
              AMAN GARG
            </Link>
          </div>
          <div class='social-icons'>
            <a href="https://www.linkedin.com/in/amanmadhavgarg/"><p class='website-rights'><i class="fab fa-linkedin-in"></i></p></a>
            <a href="mailto:garg10435@gapps.uwcsea.edu.sg"><p class='website-rights'><i class="fas fa-envelope-open"></i></p></a>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
